import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-input-textarea',
  templateUrl: './input-textarea.component.html',
})
export class InputTextareaComponent {
  @Input() value = '';
  @Input() rows = 5;
  @Input() cols = 30;
  @Input() placeholder = '';

  @Input() control!: any;
}
